<app-lt-png-table
    [gridSettingsInput]="gridSettings()"
    [showToolbarInput]="showToolbar()"
    [preselectedItemsInput]="preselectedItems()"
    (selectionChange)="onSelectionChange($event)"
    (rowSelect)="onRowSelect($event)"
    (rowUnselect)="onRowUnselect($event)"
    (columnsChange)="onColumnsChange($event)">
</app-lt-png-table>